var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Dialog', {
    attrs: {
      "title": "Edit Organization",
      "show": _vm.isOpen,
      "onClose": _vm.onCancel
    }
  }, [_c('el-form', {
    ref: "formRef",
    attrs: {
      "model": _vm.item,
      "label-width": "180px",
      "label-position": "left",
      "size": "small",
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Name",
      "prop": "name",
      "required": ""
    }
  }, [_c('el-input', {
    model: {
      value: _vm.item.name,
      callback: function ($$v) {
        _vm.$set(_vm.item, "name", $$v);
      },
      expression: "item.name"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Domain",
      "prop": "domain",
      "required": ""
    }
  }, [_c('el-input', {
    model: {
      value: _vm.item.domain,
      callback: function ($$v) {
        _vm.$set(_vm.item, "domain", $$v);
      },
      expression: "item.domain"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "SAML Metadata IdP file"
    }
  }, [_c('div', {
    staticClass: "saml-info"
  }, [_c('el-input', {
    attrs: {
      "readonly": "",
      "disabled": ""
    },
    model: {
      value: _vm.item.idp_metadata_url,
      callback: function ($$v) {
        _vm.$set(_vm.item, "idp_metadata_url", $$v);
      },
      expression: "item.idp_metadata_url"
    }
  }), _c('el-upload', {
    ref: "upload",
    attrs: {
      "auto-upload": false,
      "accept": ".xml",
      "on-change": _vm.handleFileChange,
      "file-list": _vm.fileList,
      "action": "",
      "list-type": "text"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "trigger",
      "size": "small",
      "type": "primary"
    },
    slot: "trigger"
  }, [_vm._v("Pick a file")]), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v(" A SAML XML file, provided by the IdP ")])], 1)], 1)]), _c('el-form-item', {
    attrs: {
      "label": "Sign SAML requests"
    }
  }, [_c('el-switch', {
    model: {
      value: _vm.item.sign_saml_requests,
      callback: function ($$v) {
        _vm.$set(_vm.item, "sign_saml_requests", $$v);
      },
      expression: "item.sign_saml_requests"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Zero data persistence"
    }
  }, [_c('el-switch', {
    model: {
      value: _vm.item.zero_data_persistence,
      callback: function ($$v) {
        _vm.$set(_vm.item, "zero_data_persistence", $$v);
      },
      expression: "item.zero_data_persistence"
    }
  })], 1), _c('el-divider'), _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")]), _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }